/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export function createResourceCopy(resourceFactory: any, sourceModel: any, overrides: Record<string, any>): any {
  const copyData = _.cloneDeep(sourceModel);
  Object.assign(copyData, overrides);
  return new resourceFactory(copyData);
}
